import type { FC } from "react";
import { Box } from "@mui/material";
import { HACK_alignIconWithLabel } from "@privacy/ui";
import { CLASSIFICATION_COLORS } from "./classificationColors";
import type { ClassificationPropertyKey, Level } from "./schemas";

const BADGE_SIZE = 20;

type Props = {
  propertyKey: ClassificationPropertyKey;
  value: Level;
  ariaLabel?: string;
};

export const ClassificationScoreChip: FC<Props> = ({ propertyKey, value, ariaLabel }) => (
  <Box
    role="img"
    aria-label={ariaLabel}
    sx={theme => {
      const color = CLASSIFICATION_COLORS(theme)[propertyKey][value];
      return {
        minWidth: BADGE_SIZE,
        height: BADGE_SIZE,
        px: 0.75,
        borderRadius: 1,
        backgroundColor: color.fill,
        color: color.text,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
      };
    }}
  >
    <Box component="span" sx={HACK_alignIconWithLabel}>
      {value}
    </Box>
  </Box>
);
